var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"div-background-header"}),_c('div',{staticClass:"div-body-iframe"},[_c('div',{staticClass:"div-inner-iframe"},[_c('iframe',{staticStyle:{"width":"100%","min-height":"1000px"},attrs:{"id":"ibe","src":"https://pauschalreise.schmetterling.de/search?taid=14428&agent=133564&ibe=pa"}})])])])
}]

export { render, staticRenderFns }